import SightsPage from '@/pages/sights/SightsPage.vue';

export const mfRoutes = [
  {
    path: '/attractions/:slug',
    name: 'attractions',
    component: SightsPage,
  },
];

export default mfRoutes;
